import * as api from "services/api";
import { State } from "store/reducers";

export interface IAuthToken {
	_id: string;
	token: string;
	user: string | { _id: string; email?: string; name?: string; lastname?: string };
	description?: string;
	isActive: boolean;
	lastUsed?: string;
	createdAt?: string;
	updatedAt?: string;
}

export function createAuthToken(userId: string, description?: string) {
	return async (_dispatch: any, getState: () => State) => {
		const { login } = getState();
		const response = await api.sendPost(
			"/authToken",
			{ userId, description },
			{ Authorization: `Bearer ${login.token}` }
		);
		const result = await response.json();
		if (!result.isValid) {
			const msg =
				result.errors && typeof result.errors === "object"
					? Object.values(result.errors)[0]
					: result.errors;
			throw new Error((msg as string) || "Failed to create auth token");
		}
		return result.model as IAuthToken;
	};
}

export function getAuthTokens(userId?: string) {
	return async (_dispatch: any, getState: () => State) => {
		const { login } = getState();
		const url = userId ? `/authToken?userId=${encodeURIComponent(userId)}` : "/authToken";
		const response = await api.sendGet(url, {
			Authorization: `Bearer ${login.token}`
		});
		const result = await response.json();
		if (!result.isValid) {
			const msg =
				result.errors && typeof result.errors === "object"
					? Object.values(result.errors)[0]
					: result.errors;
			throw new Error((msg as string) || "Failed to load auth tokens");
		}
		const list = result.model ?? result.data;
		return (Array.isArray(list) ? list : []) as IAuthToken[];
	};
}

export function deleteAuthToken(id: string) {
	return async (_dispatch: any, getState: () => State) => {
		const { login } = getState();
		const response = await api.sendDelete(`/authToken/${id}`, {
			Authorization: `Bearer ${login.token}`
		});
		const result = await response.json();
		if (!result.isValid) {
			const msg =
				result.errors && typeof result.errors === "object"
					? Object.values(result.errors)[0]
					: result.errors;
			throw new Error((msg as string) || "Failed to delete auth token");
		}
	};
}

export function updateAuthToken(
	id: string,
	body: { description?: string; isActive?: boolean }
) {
	return async (_dispatch: any, getState: () => State) => {
		const { login } = getState();
		const response = await api.sendPut(`/authToken/${id}`, body, {
			Authorization: `Bearer ${login.token}`
		});
		const result = await response.json();
		if (!result.isValid) {
			const msg =
				result.errors && typeof result.errors === "object"
					? Object.values(result.errors)[0]
					: result.errors;
			throw new Error((msg as string) || "Failed to update auth token");
		}
		return result.model as IAuthToken;
	};
}
